var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgScooter = function SvgScooter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M11.032 10.005A4.19 4.19 0 0 0 7.5 8.375H5.167a4.583 4.583 0 0 0-4.5 3.436 1.25 1.25 0 0 0 1.209 1.564h8.75a3.75 3.75 0 0 0 3.75-3.75v-6.25a2.5 2.5 0 0 0-2.5-2.5h-1.25",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M10.625 13.375h8.125a.624.624 0 0 0 .51-.264c.12-.599.149-1.212.083-1.82a2.5 2.5 0 0 0-2.357-1.666h-2.611",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    clipRule: "evenodd",
    d: "M16.875 5.875a.937.937 0 0 1-1.5.75 2.5 2.5 0 0 1 0-4 .938.938 0 0 1 1.5.75v2.5Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 5.875h-6.25",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    clipRule: "evenodd",
    d: "M8.125 14a3.125 3.125 0 1 1-6.25 0v-.625h6.25V14Zm10 0a3.125 3.125 0 1 1-6.25 0v-.625h6.25V14Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgScooter;